<template>
    <v-row>
        <v-col md="6" sm="12">
            <v-card variant="outlined" title="Build Model" subtitle="">
                <v-data-table style="height:400px;" :headers="tableHeaders" :items="itemList"
                    items-per-page="5" ></v-data-table>
            </v-card>
        </v-col>
        <v-col md="6" sm="12">
            <v-card variant="outlined" title="Boxplot" subtitle="">
                <div id="main" style="height:400px;"></div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'BuildModel',
    data() {
        return {
            headers: ["Step1", "Step2", "resampling_method", "rsq_internal_train_set", "rsq_internal_test_set", "rsq_initial_train_set", "rsq_external_test_(validation)_set"],
            nodes: ["Step1_by_lasso", "Step2_by_lasso", "cv-5", "0.945", "0.81", "0.954", "0.904"],
            tableHeaders: [],
            items: [],
            itemList: []
        };
    },
    created() { },
    async mounted() {
        await this.doTable()
        await this.initChart()
    },
    methods: {
        doTable() {
            for (var i in this.headers) {
                var obj = {}
                obj["title"] = this.headers[i]
                obj["value"] = this.headers[i]
                this.tableHeaders.push(obj)
            }

            var objc = {}
            for (var j in this.nodes) {
                objc[this.headers[j]] = this.nodes[j]
            }
            this.itemList.push(objc)

        },
        initChart() {
            var myChart = this.$echarts.init(document.getElementById("main"), null, { renderer: 'svg' });
            var option;
            option = {
                title: [
                    // {
                    //     text: 'Results',
                    //     left: 'center'
                    // },
                ],
                dataset: [{
                    // prettier-ignore
                    source: [
                        [0.945, 0.81, 0.954, 0.904],
                    ]
                },
                {
                    transform: {
                        type: 'boxplot',
                    }
                }],
                legend: {
                    top: '0',
                    // right: '5'
                },
                tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '10%',
                    right: '10%',
                    bottom: '15%'
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    nameGap: 30,
                    splitArea: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    name: 'rsq_internal_set',
                    nameLocation: 'middle', // 标题居中显示
                    nameRotate: 90,         // 标题旋转 90 度
                    nameGap: 40,            // 调整标题与轴线的距离
                    nameTextStyle: {
                        fontSize: 16,
                        fontWeight: 'bold',
                        color: '#333'        // 可自定义颜色
                    },
                    splitArea: {
                        show: true
                    },
                  axisLine: { // 显示 Y 轴轴线
                show: true,
                lineStyle: {
                    color: '#333', // Y 轴线颜色
                    width: 1 // 轴线宽度
                }
            },
                },
                series: [{
                    name: 'Step by lasso',
                    type: 'boxplot',
                    datasetIndex: 1
                }]
            };

            option && myChart.setOption(option);

        }
    },
}



</script>

<style scoped></style>